var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGaDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#B0B0B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ga_disabled_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 25a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM29.29 27.08l-.91 8.06-2.08-6.24 1.3-1.69c.26-.39-.13-.91-.65-.91h-2.6c-.52 0-.78.52-.65.91l1.17 1.69-2.08 6.24-1.04-8.45C16.81 28.25 13.3 32.67 13.3 38h23.4c0-4.94-3.12-9.23-7.41-10.92zM19.8 35.4h-2.6v-1.95c0-.39.26-.65.65-.65h1.3c.39 0 .65.26.65.65v1.95z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ga_disabled_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 12)",
    d: "M0 0h26v26H0z"
  })))));
}

export default SvgGaDisabled;